<template>
  <div class="headwrap size14 pagehead">
    <div class="search_result_head colorF">
      <div class="logo_i2  pointer" @click="routerHome">
        <img src="../../img/logo.png" alt="">
      </div>
      <div class="marLeft20 marRight20">|</div>
      <div>{{$t('page.global_logistics_tracking_platform')}}</div>
    </div>
    <div class="flex ycenter colorF">
      <a class="marRight30 pointer linkcss no-user-select" :class="{'linkBottom':$route.path.indexOf(item.link)!==-1}" @click="toLink(item.link,k)" v-for="(item,k) in linkarr" :key="k">{{item.name}}
        <svg v-if="item.index === 1" class="icon colorF" aria-hidden="true" style="position: absolute;font-size: 28px;right: -39px;top: 1px;z-index: 22;transform: translate(-50%, -50%);transition: all .6s;">
          <use xlink:href="#iconNew"></use>
        </svg>
      </a>
      <!--<div class="aboutYee pointer" :class="{'aboutYeeSelect':this.$route.path == '/aboutTrackingYee'}" @click="$router.push('/aboutTrackingYee')">{{$t('page.about_Tracking_Yee')}}</div>-->
      <div class="marRight30">
        <el-select
          size="small"
          style="width: 100px; margin-right: 10px;"
          v-model="lang"
          @change="changeLang"
          :placeholder="$t('page.choose_languages')">
          <el-option
            v-for="item in langItem"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="marRight10">
        <el-button style="width: 80px;" @click="routerLogin" size="small" class="loginHover transition3ms">{{$t('page.login')}}</el-button>
      </div>
      <div class="zhuce">
        <el-button style="width: 80px;" @click="routerSign" size="small" type="primary" class="btnHover transition3ms">{{$t('page.signup')}}</el-button>
      </div>
    </div>


  </div>
</template>

<script>
  // import
  export default {
    data() {
      return {
        index:0,
        linkarr:[],
        isShow:true,
        lang: 'zh-cn',
        langItem: []
      }
    },
    created() {
      this.setLang('zh-cn')
      // this.$i18n.locale = 'cn'
      // this.lang = localStorage.getItem('lang') || 'zh-cn'
      // console.log(this.$router)
      // console.log(this.$route.path,70)
    },
    mounted(){
      console.log(process.env.NODE_ENV,5555)
      let lang = this.$route.path;
      if(lang.includes('zh-cn') || lang.includes('en')){
        if(lang.indexOf('zh-cn') != -1){
          this.setLang('zh-cn')
        }else{
          this.setLang('en')
        }
      }else{
        this.justify_location();
      }
      console.log(lang)
    },
    methods: {
      setLang(lang){
        if(lang == 'zh-cn'){
          document.title = "TrackingYee-全球物流查询平台";
        }else{
          document.title = "TrackingYee-Global Shipment Tracking Platform";
        }
        this.$i18n.locale = lang
        localStorage['lang'] = lang
        this.lang = lang
        if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
          this.linkarr = [
            {
              index:0,
              name: this.$t('page.home_page'),
              link:`https://trackingyee.globalpcf.net/${this.lang}`,
            },{
              index:1,
              name:this.$t('page.functionalAdvantages_functionalAdvantages'),
              link:`https://feature.trackingyee.globalpcf.net/${this.lang}`,
            },{
              index:2,
              name:this.$t('page.carrier'),
              link:`https://carriers.trackingyee.globalpcf.net/${this.lang}`,
            },{
              index:3,
              name:this.$t('page.functionalAdvantages_externalCall'),
              link:`https://extcall.trackingyee.globalpcf.net/${this.lang}`,
            },
          ]
        } else {
          this.linkarr = [
            {
              index:0,
              name: this.$t('page.home_page'),
              link:`https://trackingyee.com/${this.lang}`,
            },{
              index:1,
              name:this.$t('page.functionalAdvantages_functionalAdvantages'),
              link:`https://feature.trackingyee.com/${this.lang}`,
            },{
              index:2,
              name:this.$t('page.carrier'),
              link:`https://carriers.trackingyee.com/${this.lang}`,
            },{
              index:3,
              name:this.$t('page.functionalAdvantages_externalCall'),
              link:`https://extcall.trackingyee.com/${this.lang}`,
            },
          ]
        }
        this.langItem = [
          {label: this.$t('page.chinese_languages'), value: 'zh-cn'},
          {label: this.$t('page.english_languages'), value: 'en'}
        ]
      },
      justify_location() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError);
          // 支持
          console.log("支持地理位置接口");
        } else {
          // 不支持
          console.log("不支持地理位置接口");
        }
      },
      geoSuccess(event) {
        // 中国的经纬度范围大约为：纬度3.86~53.55，经度73.66~135.05
        console.log("纬度:"+event.coords.latitude + ', ' +"经度:"+ event.coords.longitude);
        if(3.86 <= event.coords.latitude && event.coords.latitude <= 53.55 && 73.66 <= event.coords.longitude && event.coords.longitude <= 135.05){
          this.setLang('zh-cn')
        }else{
          this.setLang('en')
        }
      },
      //拒绝授权
      geoError(error) {
        console.log(error)
        console.log("Error code " + error.code + ". " + error.message);
        this.setLang('zh-cn')
        switch (error.code) {
          case error.PERMISSION_DENIED:
            this.$message.error("定位失败,用户拒绝请求地理定位");
            break;
          case error.POSITION_UNAVAILABLE:
            this.$message.error("定位失败,位置信息是不可用");
            break;
          case error.TIMEOUT:
            this.$message.error("定位失败,请求获取用户位置超时");
            break;
          case error.UNKNOWN_ERROR:
            this.$message.error("定位失败,定位系统失效");
            break;
        }
      },
      toLink(item,k){
        window.open(item,'_self')
        this.index = k
      },
      changeLang(lang) {
        this.$emit('changeLang',lang)
        this.setLang(lang)
        // console.log(lang)
        // this.$i18n.locale = lang
        // localStorage.setItem('lang', lang)
        // location.reload(true)
      },
      routerSign() {
        window.open('https://client.trackingyee.com/register')
      },
      routerLogin() {
        window.open('https://client.trackingyee.com/tyPortal?id=TrackingYeeHomeMenuItem')
      },
      routerHome() {
        if(process.env.NODE_ENV === 'development'|| process.env.NODE_ENV === 'test') {
          window.open(`https://www.360bbt.com/${this.lang}`,'_self')
        } else {
          window.open(`https://trackingyee.com/${this.lang}`,'_self')

        }
      }
    },
  }
</script>

<style scoped>
  .pagehead {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 1000;
    transform: translateX(-50%);
  }
  .linkcss{
    height: 30px;
    line-height: 30px;
  }
  .linkcss:hover{
    /*border-bottom: 2px solid white;*/
  }
  .linkBottom{
    border-bottom: 3px solid white;
  }
  >>> .el-input__inner{
    border: 1px solid white!important;
    background-color: transparent;
    color: white;
  }
  >>> .el-select__caret{
    color: white!important;
  }
  >>> .el-button{
    background-color: transparent;
    color: white;
  }
  .zhuce >>> .el-button{
    background-color: #289EFC;
    color: white;
  }
  .headwrap{
    display: flex;
    width: 1200px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;
  }
  .search_home {
    height: 100%;
    width: 100%;
    background-color: #ffffff;
    position: relative;
  }
  .aboutYee{
    /*position: absolute;*/
    /*top: 36px;*/
    /*right: 356px;*/
    /*height: 42px;*/
  }
  .aboutYee:hover{
    border-bottom:2px solid #289EFC;
    color: #289EFC;
  }
  .aboutYeeSelect{
    border-bottom:2px solid #289EFC;
    color: #289EFC;
  }
  .lang_box {
    position: absolute;
    top: 30px;
    right: 220px;
  }

  .lang_box2 {
    position: absolute;
    top: 30px;
    right: 130px;
  }

  .lang_box3 {
    position: absolute;
    top: 30px;
    right: 30px;
  }

  .logo_box {
    padding-top: 150px;
    width: 500px;
    margin: auto;
    text-align: center;
  }

  .logo_i {
    width: 500px;
  }

  .logo_font {
    font-size: 200px
  }

  .order_search {
    width: 800px;
    margin: auto;
  }

  .button_line {
    position: absolute;
    width: 400px;
    text-align: center;
    bottom: 50px;
    right: 50%;
  }

  .line1 {
    position: absolute;
    width: 150px;
    bottom: 55px;
    border-bottom: 1px solid #D2D2D2;
    left: 40%;
  }

  .line2 {
    position: absolute;
    width: 150px;
    bottom: 55px;
    border-bottom: 1px solid #D2D2D2;
    right: 40%;
  }

  .search_result_head {
    height: 80px;
    /*background-color: #fff;*/
    /*-moz-box-shadow: 2px 2px 5px #d2d2d2;*/
    /*-webkit-box-shadow: 2px 2px 5px #d2d2d2;*/
    /*box-shadow: 2px 2px 5px #d2d2d2;*/
    display: flex;
    line-height: 80px;
  }

  .search_result_line {
    display: flex;
    justify-content: space-between;
  }

  .logo_i2 img {
    width: 200px;
    vertical-align: middle;
  }





  a {
    position: relative;
    font-weight: 600;
    text-decoration: none;
    color: white;
    transition: color .3s ease;
  }
  a::after {
    --scale: 0;
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: 3px;
    background: white;
    -webkit-transform: scaleX(var(--scale));
    transform: scaleX(var(--scale));
    -webkit-transform-origin: 50%;
    transform-origin: 50%;
    transition: -webkit-transform 0.3s cubic-bezier(0.535, 0.05, 0.355, 1);
    transition: transform 0.3s cubic-bezier(0.535, 0.05, 0.355, 1);
  }
  a:hover::after {
    --scale: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/new/pageHead.vue